import { useMobileOS } from '@beef/react';
import { OS } from "./types";
export var IOS = function IOS(_ref) {
  var children = _ref.children;
  var os = useMobileOS();
  if (os === OS.IOS || !os) {
    return children;
  }
  return null;
};
export var Android = function Android(_ref2) {
  var children = _ref2.children;
  var os = useMobileOS();
  if (os === OS.Android || !os) {
    return children;
  }
  return null;
};